import  React,{Fragment}  from "react";
import img from "../../images/defaultBcg.jpeg";
import img2 from "../../images/gran-cru-dark.jpg";
import img3 from "../../images/room-4.jpeg";
import img4 from "../../images/olive-style.jpg";
import img5 from "../../images/room-6.jpeg";
import {withRouter} from "react-router-dom";

const Carousel =(props)=>{
    
    // const context = useContext(RoomContext);
    // const {items} = context;
 
    // console.log(items[]);
    return(
        <Fragment>
          <div className="carousel homeCarousel slide" id="homeSlider" data-rider="carousel">
              <div className="carousel-inner">
                 <ol className="carousel-indicators">
                       <li className="active" data-target="#homeSlider" data-slide-to="0"></li>
                       <li data-target="#homeSlider" data-slide-to="1"></li>
                       <li data-target="#homeSlider" data-slide-to="2"></li>
                       <li data-target="#homeSlider" data-slide-to="3"></li>
                       <li data-target="#homeSlider" data-slide-to="4"></li>
                   </ol>
                    <div className="carousel-item active">
                         <img src={img} className="img-fluid" alt="hero" />
                         <div className="carousel-layout"></div>
                         <div className="carousel-caption">
                                <h2>Luxurious Rooms</h2>
                                <p>Deluxe Rooms Starting At $299</p>
                                <button onClick={() => props.onBtnClick()} className="stylish-btn mt-2">Our Rooms</button>
                         </div>
                        
                    </div>
                    <div className="carousel-item">
                         <img src={img2} className="img-fluid" alt="hero" />
                         <div className="carousel-layout"></div>
                         <div className="carousel-caption">
                                <h2>Double Standard</h2>
                                <p>$300</p>
                                <p>400 SQFT</p>
                                <p>Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn...</p>

                                <button onClick={() => props.history.push("/rooms/double-standard")} className="stylish-btn mt-2">Read more</button>
                         </div>
                        
                    </div>
                    <div className="carousel-item">
                         <img src={img3} className="img-fluid" alt="hero" />
                         <div className="carousel-layout"></div>
                         <div className="carousel-caption">
                                <h2>Family Economy</h2>
                                <p>$400</p>
                                <p>600 SQFT</p>
                                <p>Expenses as material breeding insisted building to in...</p>
                                <button onClick={() => props.history.push("/rooms/family-economy")} className="stylish-btn mt-2">Read more</button>
                         </div>
                        
                    </div>
                    <div className="carousel-item">
                         <img src={img4} className="img-fluid" alt="hero" />
                         <div className="carousel-layout"></div>
                         <div className="carousel-caption">
                                <h2>Family Standard</h2>
                                <p>$300</p>
                                <p>400 SQFT</p>
                                <p>Much did had call new drew that kept. Limits expect wonder law she...</p>
                                <button onClick={() => props.history.push("/rooms/family-standard")} className="stylish-btn mt-2">Read more</button>
                         </div>
                        
                    </div>
                    <div className="carousel-item">
                         <img src={img5} className="img-fluid" alt="hero" />
                         <div className="carousel-layout"></div>
                         <div className="carousel-caption">
                                <h2>Single Basic</h2>
                                <p>$150</p>
                                <p>250 SQFT</p>
                                <p>Among going manor who did. Do ye is celebrated it sympathize considered...</p>
                                <button onClick={() => props.history.push("/rooms/single-basic")} className="stylish-btn mt-2">Read more</button>
                         </div>
                        
                    </div>
              </div>  
              <a href="#homeSlider" className="carousel-control-prev" data-slide="prev">
                <span className="carousel-control-prev-icon"></span>
            </a>

            <a href="#homeSlider" className="carousel-control-next" data-slide="next">
                <span className="carousel-control-next-icon"></span>
            </a>
            </div>  
        </Fragment>
    )
}
export default withRouter(Carousel);